module.exports = __webpack_public_path__ + "img/icon_enjoy04@2x.74a37969.png";